import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LeadProvider } from './Utils/LeadContext';
import IndexPage from './Modules/Index/Index';
import Guide from './Modules/Guides/Guide';
import GQik from './Modules/Guides/GQik';
import Intro from './Modules/Guides/Intro';
import Offer from './Modules/Guides/Offer';
import FeedBack from './Modules/Guides/FeedBack';
import Restart from './Modules/Restart/Restart';
import NotFoundPage from './Components/Common/NotFoundPage';
import './index.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import BookDemo from './Modules/Demo/Demo';
import { BrandProvider } from './Utils/BrandContext';
import BrandSync from './Utils/BrandSync';
import GPower from './Modules/Guides/GPower';
import { useSearchParams as useOfferParams, useNavigate as useOfferNavigate } from 'react-router-dom';
import { getImagePath } from './Utils/Utilities';
import GERP from './Modules/Guides/GERP';

const createRedirect = (targetPage, defaultScroll = '') => () => {
  const [searchParams] = useOfferParams();
  React.useEffect(() => {
    const i = searchParams.get('i') || '';
    const o = searchParams.get('o') || '';
    const m = searchParams.get('m') || '';
    const scroll = searchParams.get('scroll') || defaultScroll;
    const mQuery = m ? `&m=${m}` : '';
    const scrollQuery = scroll ? `&scroll=${scroll}` : '';
    const baseUrl = window.location.hostname === 'localhost'
      ? `http://localhost:${window.location.port}/QikERP`
      : `${window.location.origin}/QikERP`;
    window.location.href = `${baseUrl}/${targetPage}?i=${i}&o=${o}${mQuery}${scrollQuery}`;
  }, []);
  return null;
};

const GQikRedirect = createRedirect('GERP');
const OfferRedirect = createRedirect('GPower', 'pricing');

// 🔧 BRAND CONTROL: Change here to switch between 'bz' and 'qikerp'

const BrandTitle = () => {
  const { brand: activeBrand } = require('./Utils/BrandContext').useBrand();
  React.useEffect(() => {
    const faviconPath = activeBrand === 'bz' 
      ? getImagePath(`/Images/favicon.jpg`)
      : getImagePath(`/Images/QikERP_Favicon.png`);
    
    if (activeBrand === 'bz') {
      document.title = 'Biziverse - Easy & Powerful Tools to Accelerate Business';
      document.querySelector('meta[name="description"]')?.setAttribute('content', 'Biziverse ERP & CRM software for Indian MSMEs. Manage Leads, Billing, Inventory, Accounts and more.');
    } else {
      document.title = 'QikERP by Biziverse - ERP & CRM Software for Smart Businesses & MSMEs';
      document.querySelector('meta[name="description"]')?.setAttribute('content', 'QikERP by Biziverse - ERP & CRM Software for Smart Businesses & MSMEs');
    }
    
    document.querySelector('link[rel="icon"]')?.setAttribute('href', faviconPath);
  }, [activeBrand]);
  return null;
};

function App() {
  return (
    <BrandProvider defaultBrand="qikerp">
      <LeadProvider>
        <Router basename='QikERP'>
          <BrandSync />
          <BrandTitle />
          <Toaster position="bottom-right" expand={false} />
          <Routes>
            <Route path="/" element={<IndexPage />} />
            <Route path="/Guide" element={<Guide />} />
            <Route path="/GQIK" element={<GQik />} />
            <Route path="/GPower" element={<GPower />} />
            <Route path="/GERP" element={<GERP />} />
            <Route path="/Intro" element={<Intro />} />
            <Route path="/Offer" element={<OfferRedirect />} />
            <Route path="/Demo" element={<BookDemo />} />
            <Route path="/FeedBack" element={<FeedBack />} />
            <Route path="/fdbk" element={<FeedBack />} />
            <Route path="/GRestart" element={<Restart />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>

     </LeadProvider>
     </BrandProvider>
  );
}
export default App;